import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';

export interface ApplicationConfig {
  region: string;
  productionUnit: string;
  classification: string;
}

export interface CoreState {
  config: ApplicationConfig;
  status: 'idle' | 'loading' | 'failed';
  globalError: { message: string; status?: number } | null;
}

const initialState: CoreState = {
  config: {
    region: '',
    productionUnit: '',
    classification: '',
  },
  status: 'idle',
  globalError: null,
};

export const coreSlice = createSlice({
  name: 'core',
  initialState,
  reducers: {
    addConfig: (state, action: PayloadAction<ApplicationConfig>) => {
      state.config = action.payload;
    },
    setGlobalError: (
      state,
      action: PayloadAction<{ message: string; status?: number } | null>
    ) => {
      state.globalError = action.payload;
    },
  },
});

export const { addConfig, setGlobalError } = coreSlice.actions;

export const selectConfig = (state: RootState) => state.core.config;
export const selectGlobalError = (state: RootState) => state.core.globalError;

export default coreSlice.reducer;
